import { render, staticRenderFns } from "./AiVoicePtBroadcast.vue?vue&type=template&id=4bb36a80&scoped=true"
import script from "./AiVoicePtBroadcast.vue?vue&type=script&lang=js"
export * from "./AiVoicePtBroadcast.vue?vue&type=script&lang=js"
import style0 from "./AiVoicePtBroadcast.vue?vue&type=style&index=0&id=4bb36a80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb36a80",
  null
  
)

export default component.exports